import React from 'react'
import { FaCheck } from 'react-icons/fa'
import styled from 'styled-components'

const Placeholder = styled.span`
  display: block;
  width: 1rem;
  height: 1rem;
  flex: none;
`

export const DropdownMenuCheckIcon: React.FC<{ selected?: boolean }> = ({ selected }) =>
  selected ? <FaCheck /> : <Placeholder aria-hidden />
